import { createSvg } from '../createSvg';
var Danger = function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1.5 : _b;
    return <>
        <g id={'contour'}>
            <path d='M11.9999 21.41H5.93993C2.46993 21.41 1.01993 18.93 2.69993 15.9L5.81993 10.28L8.75993 5C10.5399 1.79 13.4599 1.79 15.2399
                 5L18.1799 10.29L21.2999 15.91C22.9799 18.94 21.5199 21.42 18.0599 21.42H11.9999V21.41Z' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
        </g>
        <g id={'guts'}>
            <path d='M12 9V14' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
            <path d='M11.9944 17H12.0034' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
        </g>
    </>;
};
export default createSvg(Danger, 'danger');
